<template>
  <div ref="container">
    <template v-if="loading">
      <post-skeleton v-for="i in itemsPerPage" :key="i" />
    </template>
    <template v-for="post in posts" :key="post.id">
      <post :post="post"></post>
    </template>
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        v-model:currentPage="currentPage" :page-sizes="[10,20,50,100]" :page-size="itemsPerPage" :pager-count="4"
        layout="prev, pager, next" :total="totalPosts">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import {
    defineComponent,
    ref,
    onMounted,
    watch,
    nextTick
  } from 'vue';

  import {
    countGpWechatPosts,
    getGpWechatPosts
  } from '@/api/gp-posts.js'

  import {
    ElPagination
  } from 'element-plus'

  import Post from '@/components/Post'
  import PostSkeleton from '@/components/PostSkeleton'

  export default defineComponent({

    components: {
      ElPagination,
      Post,
      PostSkeleton
    },

    setup() {

      let inIframe = false;

      try {
        inIframe = window.self !== window.top;
      } catch (e) {
        console.log(e)
        inIframe = true;
      }

      const container = ref(null);

      const posts = ref([]);

      const currentPage = ref(1);
      const itemsPerPage = ref(10);
      const totalPosts = ref(0);
      const totalPages = ref(0);

      const loading = ref(true);

      const getPosts = () => {

        loading.value = true;

        // Do not allow minimum value for start value
        let start = Math.max(0, (currentPage.value - 1) * itemsPerPage.value)

        getGpWechatPosts({
            _sort: 'publish_time:desc',
            _limit: itemsPerPage.value,
            _start: start
          })
          .then(res => {
            res.forEach(post => {
              post.id = `gpwcoa_${post.id}`;
              post.source = 'gp-wcoa';
            })
            posts.value = res;
            loading.value = false;

            nextTick().then(() => {
              if (inIframe) adjustIframeSize();
              else window.scrollTo(0, 0);
            })



          })
          .catch(err => {
            console.log(err);
            loading.value = false;
          })
      };

      const countPosts = () => {

        countGpWechatPosts().then(res => {

          totalPosts.value = res;
          totalPages.value = Math.ceil(totalPosts.value / itemsPerPage.value)

        })

        getPosts()
      };

      const adjustIframeSize = () => {
        
        if (!container.value) return;

        let newHeight = container.value.clientHeight;

        if (newHeight) {
          
          window.parent.document.getElementById("wechat-posts-embed").scrollIntoView();
          console.log('height change', newHeight)

          // window.parent.postMessage({
          //   frameHeight: newHeight
          // }, '*');

          window.parent.document.getElementById("wechat-posts-embed").style.height = (newHeight + 150) + 'px';          
        }

      }

      const handleSizeChange = (val) => {
        itemsPerPage.value = val;
      };

      const handleCurrentChange = (val) => {
        currentPage.value = val;
      };

      onMounted(countPosts)
      // onMounted(adjustIframeSize)

      watch(itemsPerPage, countPosts)
      watch(currentPage, getPosts)

      return {
        container,
        loading,
        posts,
        currentPage,
        itemsPerPage,
        totalPosts,
        totalPages,
        handleSizeChange,
        handleCurrentChange
      };
    },

    created() {

      // const framed = this.inIframe();

      // if (framed) {
      //   const resizeObserver = new ResizeObserver(() => {
      //     let newHeight = this.$refs['app'].clientHeight;

      //     if (newHeight) {
      //       console.log('height change', newHeight)
      //       window.parent.postMessage({
      //         frameHeight: newHeight
      //       }, '*');
      //     }

      //   });

      //   resizeObserver.observe(document.getElementById('app'));
      // }
    },
    methods: {
      inIframe() {
        try {
          return window.self !== window.top;
        } catch (e) {
          return true;
        }
      }
    }
  });
</script>
<style lang="scss">
  html {
    color: #313131;
  }

  #app {

    .pagination {
      width: 100%;
      display: flex;
      justify-content: center;
    }

  }

  .el-pagination {

    .el-pager {

      .number {
        background-color: #333;
        border-radius: 2px;
        color: white;
        font-size: 1rem;
        padding: 2px 4px;
        height: unset;
        margin: 0 2px;

        &:hover:not(.active) {
          opacity: .9;
        }

        &.active {
          background-color: #01a7a9;
        }
      }
    }
  }
</style>